import { useApiClient } from '../context/AppContext'
import IResourceLoader from '../types/IResourceLoader'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'
import incidentsApi from '../api/incidentsApi'
import { ILoadIncidents } from '../types/Incidents/ILoadIncidents'
import { FetchIncidents } from '../types/Incidents/FetchIncidents'
import { IIncidentsData } from '../types'

const useIncidents = (): [IResourceLoader<IIncidentsData>, ILoadIncidents] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IIncidentsData>(
    'Unable to load reported accidents'
  )

  const loader = useCallbackRef<FetchIncidents>(
    async (page: number, storeCode: string): Promise<IIncidentsData> => {
      return resource.load(async () =>
        incidentsApi.GetIncidents(apiClient, page, storeCode)
      )
    }
  )

  return [resource, loader]
}

export default useIncidents
